var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.onVisibilityChange),expression:"onVisibilityChange"}],staticClass:"text-navy-blue-01 leading-none text-4xl xl:text-heading font-canela font-light mb-3 whitespace-nowrap"},[_vm._v(_vm._s(_vm.display))])
}
var staticRenderFns = []

export { render, staticRenderFns }